import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const VisitFormPage = lazy(() => import("@/pages/VisitForm/VisitFormPage"));
const VisitForm = lazy(() => import("@/pages/VisitForm/VisitForm"));
const AddVisitForm = lazy(()=>import("@/pages/VisitForm/AddForm/AddForm"));
const VisitDetail = lazy(()=>import("@/pages/VisitForm/VisitFormDetail/VisitFormDetail"));

const VisitFormRoute: RouteConfig = {
    path: "/visitform",
    element: <VisitForm />,
    pageName: "Visit Form",
    sidebar: { show: true, icon: "/assets/media/visitFormLogo.svg" },
    permission: ["VisitFormView"],
    children: {
        MAIN: {
            path: "",
            element: <VisitFormPage />,
            pageName: "Visit Form",
            permission: ["VisitFormView"],
            sidebar: { show: false },
        },
        ADD_FORM :{
            path: "addform",
            element: <AddVisitForm />,
            pageName: "Visit Form",
            permission: ["VisitFormAdd"],
            sidebar: { show: false },
        },
        VIEW_DETAIL:{
            path: "viewdetail",
            element: <VisitDetail />,
            pageName: "Visit Form",
            sidebar: { show: false },
        }

    }
}

export default VisitFormRoute;

